import React from "react";
import { styled } from "@mui/material/styles";
import { Grid, Paper, Typography } from "@mui/material";

const StyledPaper = styled(Paper)({
  margin: 20,
  backgroundColor: "#ffffff",
  boxShadow: "0px 10px 10px #eee",
});

const StyledHeader = styled("div")({
  color: "#333",
  fontWeight: 500,
  backgroundColor: "#D3F0E0",
  fontSize: 24,
  padding: "0.8rem",
});

const StyledInputContainer = styled("div")({
  padding: "1rem",
});

const StyledLabel = styled(Typography)({
  padding: "1rem",
  color: "#666666",
  fontWeight: 500,
});

const StyledValue = styled(Typography)(({ onClick }) => ({
  padding: ".45rem",
  fontWeight: 600,
  cursor: onClick ? "pointer" : "default", 
  wordWrap: "break-word",
  "&:hover": {
    textDecoration: onClick ? "underline" : "none", // Apply underline on hover only if onClick is provided
  },
}));

const CommonCard = ({ headerTitle, data, itemsPerRow = 3 }) => {
  const renderRow = (startIndex, endIndex) => {
    return (
      <Grid container spacing={2} key={startIndex} className="common-card">
        {data.slice(startIndex, endIndex).map((item, index) => (
          <Grid item xs={12 / itemsPerRow} key={startIndex + index} style={{'borderBottom':'1px solid #80808040'}}>
            <Grid container alignItems="center" >
              <Grid item xs={6}>
                <Typography variant="body1" className="cell">
                  {item.label}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <StyledValue className="px-2" onClick={item.onClick}>{item.value}</StyledValue>
              </Grid>
            </Grid>
          </Grid>
        ))}
      </Grid>
    );
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <StyledPaper>
          <StyledHeader>
            <Typography variant="h6">{headerTitle}</Typography>
          </StyledHeader>
          <StyledInputContainer>
            {Array.from({ length: Math.ceil(data.length / itemsPerRow) }).map(
              (_, index) => (
                <React.Fragment key={index}>
                  {renderRow(
                    index * itemsPerRow,
                    Math.min((index + 1) * itemsPerRow, data.length)
                  )}
                </React.Fragment>
              )
            )}
          </StyledInputContainer>
        </StyledPaper>
      </Grid>
    </Grid>
  );
};

export default CommonCard;
